import { render } from "./spotify_podcast.vue?vue&type=template&id=5da3a8f0"
import script from "./spotify_podcast.vue?vue&type=script&lang=js"
export * from "./spotify_podcast.vue?vue&type=script&lang=js"

import "./spotify_podcast.vue?vue&type=style&index=0&id=5da3a8f0&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__